import { FC, useState } from 'react';

import { BUTTON_TYPES } from '@savgroup-front-common/constants/shared';
import { Button } from '@savgroup-front-common/core/atoms/button';
import { Modal } from '@savgroup-front-common/core/atoms/modal';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { SUPPORTED_ICON_POSITIONS } from '@savgroup-front-common/core/helpers';
import { Field } from '@savgroup-front-common/core/molecules/Field';
import { ChevronRightIcon } from '@savgroup-front-common/core/protons/icons';
import { ClaimGroupConfirmation } from '@/api/Claim/getClaimGroupConfirmationQuery';

import { ResumeCard } from '../ResumeCard';

import messages from './messages';
import { useResumeCardButton } from './ResumeCardButton.hooks';
import {
  $ResumeDescriptionProduct,
  $ResumeInfoProductTitle,
  $ResumeModalOpenButtonContainer,
  $ResumeProduct,
  $ResumeProductInfoContainer,
} from './ResumeCardButton.styles';

interface ResumeCardButtonProps {
  claimGroupConfirmation?: ClaimGroupConfirmation;
  hasPrice?: boolean;
  hasDepositPrice?: boolean;
  hasDeliveryPrice?: boolean;
  isTransportPlanFeatureEnabled?: boolean;
  isModifyDisabled?: boolean;
}

const ResumeCardButton: FC<ResumeCardButtonProps> = ({
  claimGroupConfirmation,
  hasDeliveryPrice,
  hasDepositPrice,
  hasPrice,
  isTransportPlanFeatureEnabled = false,
  isModifyDisabled = false,
}) => {
  const [openResumeModal, setOpenResumeModal] = useState(false);
  const { modelDetail, serialNumber } = useResumeCardButton({
    claimGroupConfirmation,
  });
  const handleOpenModal = () => setOpenResumeModal((prev) => !prev);

  return (
    <>
      <$ResumeDescriptionProduct>
        <$ResumeProduct>
          <$ResumeProductInfoContainer>
            <$ResumeInfoProductTitle>
              {modelDetail?.name}
            </$ResumeInfoProductTitle>

            {serialNumber && (
              <Field
                copy={serialNumber}
                label={messages.newSerialNumberLabel}
              >
                {serialNumber}
              </Field>
            )}
          </$ResumeProductInfoContainer>
        </$ResumeProduct>
        <$ResumeModalOpenButtonContainer>
          <Button
            small
            primary
            hollow
            type={BUTTON_TYPES.BUTTON}
            onClick={handleOpenModal}
            icon={<ChevronRightIcon />}
            position={SUPPORTED_ICON_POSITIONS.RIGHT}
            dataTestId="displayRequestDetails"
          >
            <SafeFormattedMessageWithoutSpread
              message={messages.resumeButton}
            />
          </Button>
        </$ResumeModalOpenButtonContainer>
      </$ResumeDescriptionProduct>

      <Modal
        isOpen={openResumeModal}
        onClose={handleOpenModal}
        shouldShowPadding={false}
      >
        <ResumeCard
          claimGroupConfirmation={claimGroupConfirmation}
          hasPrice={hasPrice}
          hasDepositPrice={hasDepositPrice}
          hasDeliveryPrice={hasDeliveryPrice}
          isTransportPlanFeatureEnabled={isTransportPlanFeatureEnabled}
          isModifyDisabled={isModifyDisabled}
        />
      </Modal>
    </>
  );
};

export default ResumeCardButton;
